<template>
    <div>
        <Toast />
        <router-view/>
    </div>
</template>

<script>

import store from "@/store";

export default {

    created() {
        const layoutColor = store.getLayoutColor();
        if(!layoutColor){
            store.setLayoutColor('light')
        }
        const staticMenu = store.getStaticMenu();
        if(!staticMenu){
            store.setStaticMenu('static')
        }
    }

}
</script>

<style>

    input {
        width: 100%;
    }

</style>
